import { Form, Formik, FormikProps } from 'formik';
import { useHistory, useRouteMatch } from 'react-router';
import Button from '@cpg-its/ads.common.button';
import { Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GuidedProcessSupportBlock } from '../../../../../../global/components/guided-process-support-block';
import { PageHeader } from '../../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../../global/components/layout/sidebar-content';
import { LabelSettingProps } from '../../../../../../global/models/epi-model';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { AnnualEnrollmentProps, NewHireProps } from '../../../../models/arc-epi-props';
import { BenefitEnrollmentStep } from '../../models/pension-enrollment-models';
import { GpsType } from '../../../../../../global/components/layout/layout-models';
import { useBasePath } from '../../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../../constants/routes';
import { NewHireEnrollmentRoutes } from '../../models/new-hire-routes';
import { AccountInfoRoutes } from '../../../../../account-info/constants/routes';
import { ConfirmationStatusCode, NewHireConfirmationRedirectModel } from '../../models/new-hire-confirmation-models';
import { setCurrentNewHireBenefitEnrollmentStep } from '../../slice/new-hire-enrollment-slices';
import { useGpsType } from '../../../../../../global/hooks/useGpsType';
import { GetPageButtonText, GetPageHeaderContent } from '../../enrollment/helpers/coverage-display-helpers';
import { MemberCoverageReview } from './member-coverage-review';
import { FormWrapper } from '../../../../../../global/components/form-wrapper';
import { TcsmModal } from '../../../../../../global/components/tcsm-modal';
import { ButtonWrapper } from '../../../../../../global/components/layout/button-wrapper';
import { onSubmit, ShouldShowMemberCafeteriaAcknowledgement, GetEnrolledPlansConfirmationPageModel } from '../helpers/member-coverage-helpers';
import { MemberCompletedCoverage, MemberCoverageFormModel, MemberNewHireEnrollmentCoverage, MemberPendingCoverage } from '../models/member-coverage-model';
import { calculateTiers, GetNewHireConfirmationRedirectModel } from '../../enrollment/helpers/coverage-form-helpers';
import { SelfText } from '../../../../../annual-enrollment/models/annual-enrollment-models';
import { CoveragePerson, declineCoverageReasonOther, GetNewHireCoverageValidationSchema, DisplayLabels, PlanTypes, DeclinedValue } from '../../enrollment/models/coverage-models';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../../../global/components/wysiwyg-with-react-link';
import { PersonCoverage } from '../../enrollment/coverage/person-coverage';
import { FormGroup } from '../../../../../../global/components/layout/form-group';
import { PlanSelectionItem } from '../../enrollment/coverage/plan-selection-item';
import { FormField } from '../../../../../../global/components/form-element/form-field';
import { DeskTopTierLabel } from '../../enrollment/coverage/tier-labels-desktop';
import { parseLov } from '../../../../../../global/helpers/form-data-helper';
import { DeskTopVolumeRateLabel } from '../../enrollment/coverage/volume-rate-desktop';
import { useCurrentGhlFormId } from '../../hooks/useCurrentGhlFormId';
import { CalculatedTiers, MemberCompensation } from '../../models/new-hire-enrollment-models';
import { PlanItemDisplay } from '../../enrollment/coverage/plan-item-display';
import { Employment } from '../../../employment/employment-model';
import { PensionEnrollmentInfo, PensionEnrollmentPlan } from '../../../pension-enrollment/models/pension-enrollment-model';
import { GetMemberValidationModel, shouldMemberNavigateCoverageStep, shouldMemberNavigateRetirementStep } from './helper/member-benefit-enrollment-helper';
import { useMemberHireDate } from '../../hooks/useMemberHireDate';
import { getCurrentTimeNY, getNumberOfDays } from '../../../../../../global/helpers/date-helpers';
import { isNepEnrollment } from '../../hooks/isNepEnrollment';



interface Props {
	basePath: string
}

export function MemberCoverageEnrollmentForm(props: Props) {

	const { basePath } = props;

	const routeMatch = useRouteMatch();
	const isReviewPath = routeMatch?.path?.includes(NewHireEnrollmentRoutes.Review);
	const isCoveragePath = routeMatch?.path?.includes(NewHireEnrollmentRoutes.Coverage);

	const settings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
	const aeSettings = useSelector<TcsmStates, AnnualEnrollmentProps>(state => state?.epiProps?.annualEnrollmentSettingsState?.epiContent);

	const displayTierMedical = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState?.tierToDisplayMedical);
	const displayTierDental = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState?.tierToDisplayDental);
	const currentStep = useSelector<TcsmStates, BenefitEnrollmentStep>(state => state?.newHireEnrollmentState.currentEnrollmentStep);
	const memberCoveragePeople = useSelector<TcsmStates, CoveragePerson[]>(state => state?.newHireEnrollmentState?.memberCoverageState?.coverage?.eligible_dependents);
	const memberPendingPlans = useSelector<TcsmStates, MemberPendingCoverage>(state => state?.newHireEnrollmentState?.memberCoverageState?.coverage?.pending);
	const memberCompletePlans = useSelector<TcsmStates, MemberCompletedCoverage>(state => state?.newHireEnrollmentState?.memberCoverageState?.coverage?.complete);
	const enrolledPension = useSelector<TcsmStates, PensionEnrollmentPlan[]>(state => state?.newHireEnrollmentState?.memberPensionInfo?.enrolled_plans);

	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
	const currentForm = useCurrentGhlFormId();

	const [removeSelfDialogGroup, setRemoveSelfFlag] = useState<PlanTypes>(PlanTypes.None);
	const [reselectSelf, setReselectSelfFlag] = useState<PlanTypes>(PlanTypes.None);
	const [previousUrl, setPreviousUrl] = useState<string>(null);
	const history = useHistory();
	const dispatch = useDispatch();
	const confirmationLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${ArcRoutes.MemberNewHireEnrollment}${NewHireEnrollmentRoutes.Confirmation}?status=${ConfirmationStatusCode.NH_MEMBER}`);
	const labelSetting = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps.labelSettingState.epiContent);
	const gpsItem = useGpsType(currentStep === BenefitEnrollmentStep.COVERAGE ? GpsType.MEMBER_NEW_HIRE_COVERAGE : GpsType.MEMBER_NEW_HIRE_REVIEW);
	const declineReasonLov = useSelector<TcsmStates, any>(state => state.lovProcState?.mlpsLov?.medicalDeclineReason);
	const declinedCoverageReasonOptions = declineReasonLov ? parseLov(declineReasonLov) : [];
	const hasMedical = memberPendingPlans?.medical?.plans?.length > 0;
	const hasDental = memberPendingPlans?.dental?.plans?.length > 0;
	const isNep = isNepEnrollment();

	const validationSchema = GetNewHireCoverageValidationSchema(
		{
			memberWillSelectMedical: null,
			memberWillSelectDental: null,
			memberWillSelectLtd: null,
			memberWillSelectStd: null,
		},
		aeSettings,
		settings,
		labelSetting,
		hasMedical,
		GetMemberValidationModel(memberPendingPlans),
	);

	const memberEmployment = useSelector<TcsmStates, Employment>(state => state?.newHireEnrollmentState?.memberEmployment);
	const memberCompensationState = useSelector<TcsmStates, MemberCompensation>(state => state?.newHireEnrollmentState?.memberCompensation);
	const memberCoverageState = useSelector<TcsmStates, MemberNewHireEnrollmentCoverage>(state => state.newHireEnrollmentState?.memberCoverageState);
	const memberPensionEnrollmentInfo = useSelector<TcsmStates, PensionEnrollmentInfo>(state => state?.newHireEnrollmentState?.memberPensionInfo);

	const newHireEnrollmentRoot = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${ArcRoutes.MemberNewHireEnrollment}`);
	const memberNewHireEnrollmentBenefitEnrollmentRoot = `${newHireEnrollmentRoot}${NewHireEnrollmentRoutes.BenefitEnrollment}`;
	const memberNewHireEnrollmentEmployeeRecordRoot = `${newHireEnrollmentRoot}${NewHireEnrollmentRoutes.EmployeeRecord}`;

	const stepEmployment = `${memberNewHireEnrollmentEmployeeRecordRoot}${AccountInfoRoutes.EmploymentSegment}`;
	const stepRetirement = `${memberNewHireEnrollmentBenefitEnrollmentRoot}${NewHireEnrollmentRoutes.Retirement}`;
	const stepCoverage = `${memberNewHireEnrollmentBenefitEnrollmentRoot}${NewHireEnrollmentRoutes.Coverage}`;
	const stepReview = `${memberNewHireEnrollmentBenefitEnrollmentRoot}${NewHireEnrollmentRoutes.Review}`;
	const relationshipPath = `${memberNewHireEnrollmentEmployeeRecordRoot}${AccountInfoRoutes.RelationshipsSegment}`;

	const hireDate = useMemberHireDate();
	const currentDate = getCurrentTimeNY();
	const eventDate = currentForm?.life_event ? currentForm?.qualifying_event_date : hireDate;
	const formattedEventDate = new Date(eventDate?.replace(/-/g, '/'));
	const numberOfDays = getNumberOfDays(formattedEventDate, currentDate);

	const handleClose = () => {
		setPreviousUrl(null);
	};

	const confirmGoback = (url: string) => {
		history.push(url);
	};

	const onCancel = () => {

		if (currentStep === BenefitEnrollmentStep.REVIEW && shouldMemberNavigateCoverageStep(memberCompensationState, memberEmployment, memberCoverageState)) {
			history.push(stepCoverage);
			return;
		}

		if (isNep) {
			history.push(relationshipPath);
			return;
		}

		if (shouldMemberNavigateRetirementStep(memberPensionEnrollmentInfo, memberCompensationState, memberEmployment)) {
			history.push(stepRetirement);
			return;
		}

		history.push(stepEmployment);
	};

	const navigateToReview = () => {
		history.push(stepReview);
	};

	const onSuccess = (response, formValues) => {
		const confirmationPageModel: NewHireConfirmationRedirectModel = GetNewHireConfirmationRedirectModel(response);
		confirmationPageModel.enrolledPlanDto = GetEnrolledPlansConfirmationPageModel(memberCompletePlans, formValues, enrolledPension);
		history.push(confirmationLink, confirmationPageModel);
	};

	const initialValues: MemberCoverageFormModel = {
		[PlanTypes.M]: null,
		[PlanTypes.D]: null,
		[PlanTypes.W]: null,
		[PlanTypes.L]: null,
		[PlanTypes.U]: null,

		medicalDependents: [],
		dentalDependents: [],

		medicalDeclineReason: null,
		medicalDeclineReasonOther: null,
		dentalDeclineReason: null,
		dentalDeclineReasonOther: null,

		memo: '',
		specialRequests: '',
		agreement: false,
		cafeteriaAcknowledgement: false,
	};

	const buttonText = GetPageButtonText(currentStep, settings);
	const pageHeader = GetPageHeaderContent(currentStep, settings, null);

	const shouldDisableSubmit = (formProps: FormikProps<MemberCoverageFormModel>) => {

		const disabled = ShouldShowMemberCafeteriaAcknowledgement(memberCompletePlans, formProps.values, numberOfDays)
			? currentStep === BenefitEnrollmentStep.REVIEW && (!formProps.values.agreement || !formProps.values.cafeteriaAcknowledgement)
			: currentStep === BenefitEnrollmentStep.REVIEW && !formProps.values.agreement;

		return disabled;
	};

	useEffect(() => {
		if (isReviewPath && currentStep !== BenefitEnrollmentStep.REVIEW) {
			dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.REVIEW));
			return;
		}

		if (isCoveragePath && currentStep !== BenefitEnrollmentStep.COVERAGE) {
			dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.COVERAGE));
		}
	}, [currentStep, isCoveragePath, isReviewPath]);

	useEffect(() => {
		dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.COVERAGE));
		if (memberPendingPlans?.medical) {
			calculateTiers(
				memberPendingPlans?.medical,
				[SelfText].concat(memberCoveragePeople?.map(d => d?.guid)),
				dispatch,
				memberCoveragePeople,
				PlanTypes.M,
			);
		}
		if (memberPendingPlans?.dental) {
			calculateTiers(
				memberPendingPlans?.dental,
				[SelfText].concat(memberCoveragePeople?.map(d => d?.guid)),
				dispatch,
				memberCoveragePeople,
				PlanTypes.D,
			);
		}
	}, [memberPendingPlans]);

	function RenderCoveragePerson(formProps: FormikProps<MemberCoverageFormModel>) {
		if (currentStep === BenefitEnrollmentStep.REVIEW) {
			return null;
		}

		if (!hasMedical && !hasDental) {
			return null;
		}

		return (
			<div className='grid-main-content'>
				<DividerSection removeDivider >
					<ContentSpacer>
						<WysiwygWithReactLink content={settings?.participantSelectionDescription} />
					</ContentSpacer>
					<FormGroup>
						{
							hasMedical &&
							<ContentSpacer>
								<PersonCoverage
									planType={PlanTypes.M}
									fieldName='medicalDependents'
									groupLabel={settings?.medicalCoverageText}
									settings={settings}
									formProps={formProps}
									eligibleDependents={memberCoveragePeople}
									plan={memberPendingPlans?.medical}
									setRemoveSelfFlag={setRemoveSelfFlag}
									setReselectSelfFlag={setReselectSelfFlag}
									removeSelfDialogGroup={removeSelfDialogGroup}
									reselectSelf={reselectSelf}
									displayPlanSelectionDioApprover
								/>
							</ContentSpacer>
						}
						{
							hasDental &&
							<PersonCoverage
								planType={PlanTypes.D}
								fieldName='dentalDependents'
								groupLabel={settings?.dentalCoverageText}
								settings={settings}
								formProps={formProps}
								eligibleDependents={memberCoveragePeople}
								plan={memberPendingPlans?.dental}
								setRemoveSelfFlag={setRemoveSelfFlag}
								setReselectSelfFlag={setReselectSelfFlag}
								removeSelfDialogGroup={removeSelfDialogGroup}
								reselectSelf={reselectSelf}
								displayPlanSelectionDioApprover
							/>
						}
					</FormGroup>
				</DividerSection>
			</div>
		);
	}

	function RenderNoCoverageReasonOther(formProps: FormikProps<any>, fieldName: string, otherFieldName: string) {
		if (formProps?.values[fieldName] !== declineCoverageReasonOther) return null;

		return (
			<>
				<p className='custom-sublabel'>{settings?.declineCoverageReasonSelectMessage}</p>
				<FormField
					name={otherFieldName}
					label={aeSettings.declineMedicalCoverageReasonOtherLabel}
					component='input'
					multiline
					rows={5}
					touched={formProps.touched}
					errors={formProps.errors}
					required
				/>
			</>
		);
	}

	function RenderNoCoverageReason(
		formProps: FormikProps<any>,
		selectedMedicalPlan: string,
		fieldName: string,
		otherFieldName: string,
		memberEnroll: boolean,
	) {
		if ((selectedMedicalPlan !== DeclinedValue) || memberEnroll) return null;

		if (selectedMedicalPlan !== DeclinedValue) return null;

		return (
			<div className='grid-nested'>
				<div className='grid-main-content'>

					<DividerSection greySection>
						<ContentSpacer>
							<h2>{settings.declineCoverageReasonGroupTitle}<span className='red-text'>*</span></h2>
						</ContentSpacer>
						<FormGroup>
							<div className='form-item'>
								<FormField
									name={fieldName}
									label={settings.declineCoverageReasonSelectLabel}
									component='input'
									options={declinedCoverageReasonOptions}
									errors={formProps.errors}
									touched={formProps.touched}
									select
									required
									placeholder={settings.declineCoverageReasonSelectPlaceHolder}
								/>

							</div>
							{RenderNoCoverageReasonOther(formProps, fieldName, otherFieldName)}
						</FormGroup>
					</DividerSection>
				</div>
			</div>
		);
	}

	function RenderPlans(formProps: FormikProps<MemberCoverageFormModel>) {
		if (currentStep === BenefitEnrollmentStep.REVIEW) {
			return <MemberCoverageReview settings={settings} labelSettings={labelSetting} formProps={formProps} setEditUrl={setPreviousUrl} basePath={basePath} />;
		}

		return (
			<>
				{
					memberCompletePlans?.medical?.plan?.name &&
					<PlanItemDisplay
						planType={PlanTypes.M}
						groupLabel={settings?.medicalPlanTitle}
						settings={settings}
						plan={memberCompletePlans?.medical}
					/>
				}
				{
					memberPendingPlans?.medical &&
					<>
						<PlanSelectionItem
							memberEnroll={false}
							formikProps={formProps}
							componentModel={
								{
									formPlanTypeName: PlanTypes.M,
									planTypeName: settings?.medicalPlanTitle,
									planNamesLabel: settings?.medicalPlansLabel,
									settings,
									labelSettings: labelSetting,
									declineOptionText: settings?.declineMedicalPlanOptionText,
								}
							}
							plans={memberPendingPlans?.medical}
							radioTableLabels={<DeskTopTierLabel settings={settings} tiers={memberPendingPlans?.medical?.plans[0]?.rates_by_tier} />}
							setRemoveSelfFlag={setRemoveSelfFlag}
							tierKey='tierToDisplayMedical'
							noPlanOfferMessage={settings?.noPlanOfferMessage}
							memberSelection
							displayLabels={DisplayLabels.MEDICALDENTAL}
							eligibleDependents={memberCoveragePeople}
							displayPlanSelectionDioApprover
						/>
						{
							RenderNoCoverageReason(
								formProps,
								formProps?.values?.M,
								'medicalDeclineReason',
								'medicalDeclineReasonOther',
								false,
							)
						}
					</>
				}
				{
					memberCompletePlans?.dental?.plan?.name &&
					<ContentSpacer>
						<PlanItemDisplay
							planType={PlanTypes.D}
							groupLabel={settings?.dentalPlanTitle}
							settings={settings}
							plan={memberCompletePlans?.dental}
						/>
					</ContentSpacer>
				}
				{
					memberPendingPlans?.dental &&
					<>
						<PlanSelectionItem
							memberEnroll={false}
							formikProps={formProps}
							componentModel={
								{
									formPlanTypeName: PlanTypes.D,
									planTypeName: settings?.dentalPlanTitle,
									planNamesLabel: settings?.dentalPlansLabel,
									settings,
									labelSettings: labelSetting,
									declineOptionText: settings?.declineDentalPlanOptionText,
								}
							}
							plans={memberPendingPlans?.dental}
							radioTableLabels={<DeskTopTierLabel settings={settings} tiers={memberPendingPlans?.dental?.plans[0]?.rates_by_tier} />}
							setRemoveSelfFlag={setRemoveSelfFlag}
							tierKey='tierToDisplayDental'
							noPlanOfferMessage={settings?.noPlanOfferMessage}
							memberSelection
							displayLabels={DisplayLabels.MEDICALDENTAL}
							eligibleDependents={memberCoveragePeople}
							displayPlanSelectionDioApprover
						/>
					</>
				}
				{
					memberCompletePlans?.group_life?.plan?.name &&
					<div className='grid-main-content'>
						<ContentSpacer>
							<PlanItemDisplay
								planType={PlanTypes.G}
								groupLabel={settings?.groupLifePlanTitle}
								settings={settings}
								plan={memberCompletePlans?.group_life}
							/>
						</ContentSpacer>
					</div>
				}
				{
					memberCompletePlans?.short_term_disability?.plan?.name &&
					<div className='grid-main-content'>
						<ContentSpacer>
							<PlanItemDisplay
								planType={PlanTypes.W}
								groupLabel={settings?.shortDisPlanTitle}
								settings={settings}
								plan={memberCompletePlans?.short_term_disability}
							/>
						</ContentSpacer>
					</div>
				}
				{
					memberPendingPlans?.short_term_disability &&
					<PlanSelectionItem
						memberEnroll={false}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.W,
								planTypeName: settings?.shortDisPlanTitle,
								planNamesLabel: settings?.shortDisPlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineShortDisPlanOptionText,
							}
						}
						plans={memberPendingPlans?.short_term_disability}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.RATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.RATE}
						memberSelection
						displayPlanSelectionDioApprover
					/>
				}
				{
					memberCompletePlans?.long_term_disability?.plan?.name &&
					<div className='grid-main-content'>
						<ContentSpacer>
							<PlanItemDisplay
								planType={PlanTypes.L}
								groupLabel={settings?.longDisPlanTitle}
								settings={settings}
								plan={memberCompletePlans?.long_term_disability}
							/>
						</ContentSpacer>
					</div>
				}
				{
					memberPendingPlans?.long_term_disability &&
					<PlanSelectionItem
						memberEnroll={false}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.L,
								planTypeName: settings?.longDisPlanTitle,
								planNamesLabel: settings?.longDisPlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineLongDisPlanOptionText,
							}
						}
						plans={memberPendingPlans?.long_term_disability}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.RATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.RATE}
						memberSelection
						displayPlanSelectionDioApprover
					/>
				}
				{
					memberCompletePlans?.UEI?.plan?.name &&
					<div className='grid-main-content'>
						<ContentSpacer>
							<PlanItemDisplay
								planType={PlanTypes.U}
								groupLabel={settings?.ueiPlanTitle}
								settings={settings}
								plan={memberCompletePlans?.UEI}
							/>
						</ContentSpacer>
					</div>
				}
				{
					memberPendingPlans?.UEI &&
					<PlanSelectionItem
						memberEnroll={false}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.U,
								planTypeName: settings?.ueiPlanTitle,
								planNamesLabel: settings?.ueiPlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineUeiPlanOptionText,
							}
						}
						plans={memberPendingPlans?.UEI}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.RATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.RATE}
						memberSelection
						displayPlanSelectionDioApprover
					/>
				}
			</>
		);
	}

	function RenderFormContent(formProps: FormikProps<MemberCoverageFormModel>) {

		return (
			<>

				{
					RenderPlans(formProps)
				}
			</>
		);

	}

	return (
		<Formik
			initialValues={initialValues}
			onSubmit={(values) =>
				onSubmit(
					dispatch,
					currentStep,
					onSuccess,
					values,
					guid,
					currentForm?.employer?.client_number,
					currentForm?.id,
					memberCoveragePeople,
					displayTierMedical,
					displayTierDental,
					navigateToReview,
					memberPendingPlans,
				)}
			enableReinitialize
			validationSchema={validationSchema}
		>
			{(formProps: FormikProps<MemberCoverageFormModel>) =>
				<Form className='grid-fw-content grid-nested'>

					<FormWrapper
						formikProps={formProps}
						submitText={buttonText?.continue}
						cancelText={buttonText?.prev}
						onCancel={onCancel}
						preventButtonDisableValidation
						helperText={currentStep === BenefitEnrollmentStep.COVERAGE && settings?.memberCoverageContinueDescription}
						submitDisabled={shouldDisableSubmit(formProps)}
					>
						<div className='grid-main-content'>
							<PageHeader
								headerText={pageHeader?.title}
								description={pageHeader?.description} />
							<Hidden mdUp>
								<SideBarContent>
									<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
								</SideBarContent>
							</Hidden>
							{
								RenderCoveragePerson(formProps)
							}
						</div>
						<Hidden smDown>
							<div className='grid-sidebar'>
								<SideBarContent>
									<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
								</SideBarContent>
							</div>
						</Hidden>
						{
							RenderFormContent(formProps)
						}
					</FormWrapper>
					<TcsmModal
						open={previousUrl != null}
						handleClose={handleClose}>
						<>
							<h2>{aeSettings.previousStepModalTitle}</h2>
							<div dangerouslySetInnerHTML={{ __html: aeSettings?.previousStepModalDescription }} />
							<ButtonWrapper flexEnd>
								<Button type='button' buttonStyle='tertiary' text={aeSettings?.previousStepModalCancel} backgroundColor='#808080' onClick={handleClose} />
								<Button type='button' buttonStyle='primary' text={aeSettings?.previousStepModalConfirm} backgroundColor='#0000FF' onClick={() => confirmGoback(previousUrl)} />
							</ButtonWrapper>
						</>

					</TcsmModal>
				</Form>}
		</Formik >
	);
}